import * as Icons from '../icons'

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'

import { R5TextField } from '../shared'
import _ from 'lodash'
import gql from 'graphql-tag'
import makeStyles from '@mui/styles/makeStyles'
import { styles } from '../../constants/styles'
import { useMutation } from '../../hooks'
import { useNavigate } from '@reach/router'

export function InboundIntegrationModal({
  integration,
  setIntegration,
  setShowAddIntegrationModal,
  showAddIntegrationModal,
  teamId,
}) {
  const integrationMutation = useMutation(CREATE_INTEGRATION)
  const navigate = useNavigate()
  const classes = useStyles()

  const [loading, setLoading] = useState(false)

  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [validationErrors, setValidationErrors] = useState({})

  useEffect(() => {
    setName(integration.name || '')
  }, [integration])

  async function handleSubmit(event) {
    event.preventDefault()
    setLoading(true)

    try {
      const response = await integrationMutation({
        name,
        description,
        provider: integration.provider,
        teamId,
      })
      setLoading(false)

      navigate(
        `/teams/${teamId}/integrations/${response.data.createIntegration.integration.id}`
      )
    } catch (error) {
      setLoading(false)
      if (error.errors) setValidationErrors(error.errors)
    }
  }

  function handleClose() {
    setShowAddIntegrationModal(false)
    setIntegration({})
  }

  function renderFooter() {
    return (
      <Box className="flex flex-1 flex-row my-sm justify-end">
        <Box className="flex flex-row items-center">
          <Button
            classes={{ root: classes.marginRight }}
            onClick={handleClose}
            size="large"
          >
            Cancel
          </Button>
          <Button
            disabled={loading}
            size="large"
            type="submit"
            variant="contained"
          >
            Add
          </Button>
        </Box>
      </Box>
    )
  }

  return (
    <Dialog
      aria-labelledby="add-integration-dialog-title"
      aria-describedby="add-integration-dialog-description"
      fullWidth
      onClose={handleClose}
      open={showAddIntegrationModal}
      maxWidth="xs"
    >
      <DialogTitle id="add-integration-dialog-title">
        <Box className="flex flex-row justify-between items-center">
          <Typography style={styles.headerTitleStyle} variant="h4">
            Create {integration.name} Integration
          </Typography>
          <IconButton onClick={handleClose} size="small">
            <Icons.Close color={styles.primary.color} size={20} />
          </IconButton>
        </Box>
      </DialogTitle>
      <Divider className={classes.divider} />
      <form onSubmit={handleSubmit}>
        <DialogContent className="flex flex-col p-xl mb-md">
          <R5TextField
            error={_.some(validationErrors['name'])}
            label="Name"
            onChange={setName}
            placeholder="Integration Name"
            required
            value={name}
          />
          <R5TextField
            error={_.some(validationErrors['description'])}
            label="Description"
            onChange={setDescription}
            placeholder="What this integration is used for"
            value={description}
          />
        </DialogContent>
        <Divider />
        <DialogActions>{renderFooter()}</DialogActions>
      </form>
    </Dialog>
  )
}

const useStyles = makeStyles((theme) => ({
  actions: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  card: {
    borderRadius: theme.spacing(1),
  },
  content: {
    padding: theme.spacing(5),
  },
  description: {
    fontSize: 12,
    marginTop: theme.spacing(1),
  },
  header: {
    height: 181,
  },
  marginRight: {
    marginRight: theme.spacing(1),
  },
  name: {
    fontSize: 16,
    fontWeight: 600,
    marginTop: theme.spacing(1),
  },
  subtitle: {
    fontSize: 14,
    fontWeight: 600,
    marginTop: theme.spacing(2),
  },
}))

const CREATE_INTEGRATION = gql`
  mutation CreateIntegration($input: CreateIntegrationInput!) {
    createIntegration(input: $input) {
      integration {
        id
        name
      }
    }
  }
`
